/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Bank: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <circle cx='16' cy='16' r='16' fill='#959595' />
    <path
      d='M15.7002 9.31247C15.9232 9.2152 16.1827 9.23155 16.3936 9.3613L22.8936 13.3613C23.1791 13.5372 23.313 13.8814 23.2217 14.2041C23.1303 14.5269 22.8356 14.75 22.5 14.75H21.75V20.75H22.5L22.5772 20.7539C22.9551 20.7925 23.25 21.1118 23.25 21.5C23.25 21.8881 22.9552 22.2074 22.5772 22.2461L22.5 22.25H9.50004C9.08586 22.2499 8.75004 21.9142 8.75004 21.5C8.75005 21.0858 9.08586 20.75 9.50004 20.75H10.25V14.75H9.50004C9.16452 14.7499 8.86974 14.5269 8.77836 14.2041C8.68715 13.8814 8.82106 13.5372 9.10649 13.3613L15.6065 9.3613L15.7002 9.31247ZM16.75 14.75V20.75H20.25V14.75H16.75ZM11.75 20.75H15.25V14.75H11.75V20.75ZM12.1504 13.25H19.8497L16 10.8808L12.1504 13.25Z'
      fill='white'
    />
  </React.Fragment>
)
